import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import {
  BoldHeader,
  ButtonCore,
  getRandomLinkId,
  NormalDesc,
  Bold16,
} from "../components/common";
import "./bankconnect.scss";
import { FinBoxBankConnect } from "finbox-bank-connect-js";

const Main = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  border-radius: 4px;
  background-color: white;
  display: flex;
  padding: 16px;
  border-radius: 12px 0px 0px 0px;
  flex-direction: column;
  width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 10px;
  align-items: center;
`;

const CreateNewButton = styled.div`
  font-size: 14px;
  font-weight: 700;
  background-color: ${(props) => (props.isbankLoaded ? "#24ca7a" : "#cecece")};
  color: ${(props) => (props.isbankLoaded ? "white" : "#777777")};
  border-radius: 2px;
  padding: 7px 20px;
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: ${(props) => (props.isbankLoaded ? "pointer" : "default")};
  /* margin: -14px 40px 14px 0; */
  &:hover {
    background-color: ${(props) =>
      props.isbankLoaded ? "#139e66" : "#cecece"};
  }
`;

const LinkStyle = styled.button`
  display: flex;
  background: none;
  font-weight: 400;
  align-items: center;
  font-size: 14px;
  margin: 15px 0 3px 0;
  color: #24ca7a;
  cursor: pointer;
  :hover {
    color: #24ca7a;
    text-decoration: underline;
  }
  :link {
    color: #24ca7a;
    /* text-decoration: underline; */
  }
  :visited {
    color: #24ca7a;
    /* text-decoration: underline; */
  }
  :active {
    color: #24ca7a;
    /* text-decoration: underline; */
  }
`;

function BCEmptyState(props) {
  return (
    <div>
      <Main>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <img
            src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/bc-empty-state.svg"
            height={200}
            className="emptyimage"
          />
          <TextContainer>
            <BoldHeader>Upload your first statement</BoldHeader>
            <NormalDesc style={{ marginTop: 10 }}>
              Upload a PDF bank statement or access using Netbanking.
            </NormalDesc>

            <CreateNewButton
              style={{ marginTop: 30 }}
              isbankLoaded={props.isbankLoaded}
              onClick={() => (props.isbankLoaded ? props.ApiCall() : "")}
            >
              Launch Client SDK
            </CreateNewButton>
          </TextContainer>
          <Bold16 className="sampleData">Need Sample Data?</Bold16>
          <div style={{ display: "flex" }}>
            <LinkStyle
              as="a"
              download
              href="https://finbox-cdn.s3.ap-south-1.amazonaws.com/statements/sample_statements.zip"
              target="_blank"
              style={{ fontSize: 14 }}
            >
              Download sample data to get started
            </LinkStyle>
          </div>
        </div>
      </Main>
    </div>
  );
}

export default BCEmptyState;
